<script>
import { Doughnut } from 'vue-chartjs';
// TP1/TODO: je to staticke az se to bude predelavat s BE tak to udelam v TS
export default {
	name: 'Doughnut',
	extends: Doughnut,
	props: {
		options: { type: Object, default: () => {} },
	},
	mounted() {
		this.renderChart({
			labels: ['Otevřená', 'V přípravě', 'Uvolněné', 'Uzavřené'],
			datasets: [
				{
					label: 'GitHub Commits',
					backgroundColor: ['#62a84c', '#3aa6ff', '#ffad03', '#b6b9ba'],
					data: [40, 20, 12, 11],
				},
			],
		});
	},
};
</script>

<style scoped>

</style>
